import styled from '@emotion/styled'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { StyledMessageBanner } from '../../banners/MessageBanner/MessageBanner.styled'

export const StyledFeatureArticleBreachNotification = styled('div')({
    width: '100%',

    '@media screen and (min-width: 1180px)': {
        marginTop: calcRem(-144),

        [`${StyledMessageBanner}`]: {
            paddingTop: calcRem(120),
        },
    },
})
